import { EmailAuthForm } from "./EmailAuthForm";
import { GoogleButton } from "./GoogleButton";

export const AuthPanel = ({ returnPath = "/", onSuccess, testPrefix = "auth" }) => (
  <div className="space-y-4" data-testid={`${testPrefix}-auth-panel`}>
    <EmailAuthForm onSuccess={onSuccess} testPrefix={testPrefix} />
    <div className="flex items-center gap-3 text-[11px] text-muted-foreground"><span className="h-px flex-1 bg-border" />or<span className="h-px flex-1 bg-border" /></div>
    <GoogleButton returnPath={returnPath} label="Continue with Google" className="w-full h-10" testId={`${testPrefix}-google-signin-button`} />
  </div>
);
